<!--
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
-->
<template>
  <div v-if="show" :class="$style['wps-login-container']" @click="login">
    <div :class="$style['wps-login-panel']">
      <div :class="$style.header">
        <Icon type="qq" />
        <h2>{{ $t('e50183bd00') }}</h2>
        <h3>{{ $t('e5031ab679') }}</h3>
      </div>
      <div :class="$style.section">
        <a href="javascript:;" :class="$style['wps-wechat-login']">
          <div :class="[$style['wps-login-icon'], $style['wechat']]">
            <div :class="$style['border']">
              <span :class="$style['components-icons-box']">
                <svg
                  t="1581671799549"
                  :class="$style['icon-wechat']"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5083"
                  width="32"
                  height="32"
                >
                  <path
                    d="M669.03 317.396c10.18 0 20.235 0.748 30.237 1.865C672.1 192.728 536.831 98.731 382.415 98.731 209.797 98.73 68.38 216.39 68.38 365.797c0 86.242 47.044 157.061 125.674 211.988l-31.406 94.468L272.403 617.2c39.303 7.781 70.81 15.765 110.01 15.765 9.85 0 19.626-0.482 29.324-1.243-6.144-20.996-9.698-42.983-9.698-65.793 0.002-137.196 117.806-248.533 266.99-248.533z m-168.862-85.14c23.639 0 39.302 15.55 39.302 39.186 0 23.536-15.664 39.3-39.302 39.3-23.536 0-47.147-15.765-47.147-39.3 0-23.635 23.612-39.185 47.147-39.185z m-219.765 78.487c-23.538 0-47.3-15.765-47.3-39.3 0-23.635 23.764-39.185 47.3-39.185 23.534 0 39.2 15.55 39.2 39.185 0 23.535-15.666 39.3-39.2 39.3z"
                    fill="#1A8C2A"
                    p-id="5084"
                  ></path>
                  <path
                    d="M955.618 562.147c0-125.543-125.622-227.882-266.734-227.882-149.413 0-267.09 102.339-267.09 227.882 0 125.77 117.677 227.88 267.09 227.88 31.279 0 62.838-7.898 94.243-15.766l86.12 47.17-23.612-78.473c63.04-47.286 109.983-109.993 109.983-180.81z m-353.311-39.289c-15.639 0-31.431-15.549-31.431-31.416 0-15.652 15.792-31.405 31.43-31.405 23.74 0 39.304 15.754 39.304 31.405 0 15.867-15.563 31.416-39.303 31.416z m172.72 0c-15.538 0-31.201-15.549-31.201-31.416 0-15.652 15.664-31.405 31.202-31.405 23.536 0 39.3 15.754 39.3 31.405 0.001 15.867-15.764 31.416-39.3 31.416z"
                    fill="#1A8C2A"
                    p-id="5085"
                  ></path>
                </svg>
              </span>
            </div>
          </div>
          <span :class="$style['tip']">{{ $t('c870026dfc') }}</span>
        </a>
        <a href="javascript:;" :class="$style['wps-email-login']">
          <div :class="$style['wps-login-icon email']">
            <div :class="$style['border']">
              <span :class="$style['components-icons-box']">
                <svg
                  t="1581671825158"
                  :class="$style['icon-qq']"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5210"
                  width="32"
                  height="32"
                >
                  <path
                    d="M273.51 480.174l-1.198-3.727-0.972-4.844-0.646-2.652v-10.926l1.158-4.3 1.177-4.547 1.557-4.772 2.099-5.315 2.754-5.52 3.892-5.529v-3.87l0.378-3.625 0.605-4.926 1.669-5.54 1.536-5.98 1.229-2.744 1.413-2.56 1.822-2.847 1.987-2.12v-13.67l1.147-7.045 1.157-8.182 2.058-9.79 2.837-10.188 2.11-5.601 2.088-6.093 2.294-5.683 2.744-6.093 2.796-6.666 3.215-6.247 3.615-6.666 4.557-6.656 2.109-3.82 2.243-3.123 4.884-7.045 5.028-7.025 5.704-7.229 6.113-7.035 6.635-6.932 6.923-7.127 8.376-7.69 5.314-4.68 6.482-5.049 6.574-4.454 7.107-4.28 6.83-3.81 7.7-3.154 8.182-3.88 8.13-2.663 8.111-2.765 8.765-2.744 8.756-2.089 9.205-1.74 9.34-1.506 9.215-1.229 9.206-1.26 9.82-0.532h29.01l9.667 1.219 9.717 1.157 9.902 1.034 9.196 2.212 9.708 2.068 9.113 2.376 9.984 2.652 9.134 3.236 8.745 3.697 9.339 3.911 8.52 4.27 8.284 4.752 8.12 5.232 6.994 4.864 3.246 2.745 3.4 2.007 6.492 5.509 5.468 5.325 5.458 5.509 5.315 6.082 4.382 5.899 5.223 6.092 3.635 6.544 3.686 5.816 3.912 6.769 3.246 5.888 5.458 12.462 2.683 6.44 2.1 5.97 2.098 6.483 1.885 6.092 1.31 5.243 1.7 6.165 2.98 11.008 1.905 9.636 1.239 9.318 1.065 7.496 1.679 11.417 0.379 1.813 1.341 2.058 3.615 5.909 2.324 4.003 2.059 4.168 2.621 4.465 2.314 5.355 1.506 5.479 1.638 6.01 1.24 6.165 0.562 3.031 0.523 3.738v3.246l-0.523 3.215v4.004l-0.942 3.88-1.72 7.517-1.976 3.799-1.465 4.27v1.065l0.697 1.321 1.966 3.123 8.56 12.667 6.759 9.513 3.236 6.349 4.362 6.953 3.799 7.618 4.383 8.141 4.382 9.155 4.936 10.363 2.785 6.348 2.54 6.206 2.191 6.543 2.16 5.888 1.65 6.185 1.679 5.806 2.12 11.326 1.679 11.57 1.157 10.261v14.48l-0.778 5.13-1.106 8.858-1.516 7.956-2.355 7.22-0.88 2.938-1.65 3.543-1.371 2.468-1.844 3.041-1.618 1.915-2.058 2.478-1.843 1.997-1.966 1.71-2.355 1.034-2.12 1.035-1.74 0.573h-2.664l-1.7-0.573-3.236-1.598-1.485-1.065-1.556-1.116-1.7-1.526-1.72-1.71-2.837-3.154-3.358-4.454-2.642-4.598-2.642-3.676-2.58-4.28-3.636-7.598-4.086-7.906-0.481-0.276h-0.676l-1.659 1.239-0.962 2.079-1.598 2.58-2.785 7.68-4.198 10.926-5.376 13.148-4.045 6.554-4.24 6.84-5.038 7.69-5.345 7.527-2.734 3.41-3.318 3.717-7.629 7.496 0.666 0.675 1.034 1.076 3.81 2.232 15.872 7.629 6.922 3.901 6.605 3.789 6.533 4.772 5.826 4.915 2.816 2.222 2.12 2.56 2.181 2.97 1.802 3.215 0.973 2.673 1.188 3.205 0.512 2.775 0.563 3.236-0.563 2.17v2.202l-0.512 2.273-1.188 2.08-0.45 1.627-1.086 1.977-2.877 3.922-2.663 3.143-2.058 2.355-1.72 1.741-4.383 3.195-4.956 2.785-5.284 2.663-5.663 2.56-6.318 2.478-3.4 1.034-2.98 0.84-7.341 1.71-7.578 1.628-7.619 1.618-8.284 1.352-8.54 0.358-8.755 1.055h-27.177l-9.8-0.574-9.124-0.84-9.84-1.351-9.759-1.044-10.28-1.434-9.964-2.478-9.718-1.874-9.657-2.765-9.902-3.543-9.717-2.929-5.12-1.71-4.547-1.618-2.877-1.116-2.857-0.604h-8.08l-9.339-0.655-4.72-0.482-6.083-0.675-3.901 3.532-5.325 3.328-7.22 3.513-7.986 4.382-4.854 2.376-5.069 1.884-11.192 4.578-6.083 1.525-6.38 1.72-8.847 1.721-5.54 0.43-5.857 0.502-6.113 0.676-7.117 0.266H375.84l-16.415-0.266-15.944-1.608-8.069-1.147-7.792-1.157-7.588-1.137-7.588-1.525-7.076-2.284-7.035-1.628-6.349-2.55-6-2.376-5.602-2.672-4.864-2.919-4.823-3.553-1.648-1.72-2.16-2.079-1.64-1.812-1.474-2.09-1.362-2.078-1.054-2.1-1.526-4.454-0.533-2.304-0.676-2.56v-2.365l0.676-2.673v-2.652l0.533-2.652v-5.356l0.256-2.826 1.27-3.236 1.054-3.235 1.915-3.902 1.403-1.505 1.157-1.741 3.02-3.697 2.407-1.904 2.274-1.331 2.099-1.69 3.318-1.055 2.662-1.618 3.318-1.71 3.778-1.136 3.8-1.158 4.403-0.962 4.167-0.553 4.946-0.645 5.366-0.41 1.393-0.46h0.307l0.676-0.574v-0.655l-0.983-1.332-2.847-1.351-7.117-6.165-4.782-3.809-5.53-4.844-5.57-5.417-5.796-6.922-6.677-7.803-2.488-4.219-3.297-4.362-2.847-5.038-2.56-5.509-3.45-5.243-2.254-5.98-2.682-5.97-2.683-6.656-1.946-6.38-1.853-7.884-0.553-0.287h-0.564l-0.286-0.563h-0.686l-1.127 0.563-0.563 0.287-0.778 1.32-0.277 1.608-0.583 1.434-1.014 2.386-3.256 5.796-1.69 3.512-2.683 3.062-2.847 3.686-3.143 4.086-3.318 3.625-3.901 3.512-3.605 3.298-3.994 2.621-4.362 2.734-4.198 1.628-4.946 1.24-4.854 0.47h-1.147l-1.116-0.47-0.88-1.926-1.424-0.942-1.864-4.567-1.167-2.468-1.25-3.543-1.033-3.676-0.553-3.625-1.536-8.253-0.584-4.864V635.72l0.584-11.91 0.962-6.082 1.127-6.267 1.034-6.748 1.833-6.277 2.058-7.23 2.12-7.045 2.836-7.25 2.673-6.912 3.696-7.014 3.43-7.608 4.2-7.138 4.935-7.7 5.017-6.922 5.243-7.7 4.373-5.367 5.601-6.144 5.898-6.195 2.745-2.949 3.328-3.318 4.833-4.188 4.966-4.27 8.08-7.24 6.093-4.454z"
                    fill="#535252"
                    p-id="5211"
                  ></path>
                </svg>
              </span>
            </div>
          </div>
          <span :class="$style['tip']">{{ $t('e7647cd875') }}</span>
        </a>
      </div>
      <div :class="$style.footer">
        <a>
          <span :class="$style['components-icons-box']">
            <svg
              t="1581671858602"
              :class="$style['icon-shouji']"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5336"
              width="32"
              height="32"
            >
              <path
                d="M768 767.92V192.159c0-34.99-28.569-64.158-63.81-64.158H319.81c-34.816 0-63.81 28.725-63.81 64.158v575.763V704h512v63.92zM192 192.376C192 121.475 248.796 64 319.975 64h384.05C774.703 64 832 121.412 832 192.375v639.25C832 902.525 775.204 960 704.025 960h-384.05C249.297 960 192 902.588 192 831.625v-639.25zM512 896c35.346 0 64-28.654 64-64 0-35.346-28.654-64-64-64-35.346 0-64 28.654-64 64 0 35.346 28.654 64 64 64z"
                fill="#535252"
                p-id="5337"
              ></path>
            </svg> </span
          >{{ $t('07b380074b') }}</a
        >
        <span>|</span>
        <a :class="$style.other">{{ $t('67921724dd') }} &nbsp;&nbsp;&gt;</a>
      </div>
    </div>
  </div>
</template>
<script>
import Icon from '@src/commonComponents/Icon/index.vue'
import { isMobile } from '@util'
import {
  isWPSClient,
  registerLogin,
  removeRegisterLogin,
  callLogin,
} from '@util/wpsoffice'
import { getQuery, isVBAWorkflow, isIframe } from '@util'
export default {
  components: {
    Icon,
  },
  data() {
    return {
      show: false,
    }
  },
  watch: {
    '$store.state.registerLoginStatus': function (val) {
      if (val) {
        this.registerLogin()
      } else {
        this.removeRegisterLogin()
      }
    },
  },
  mounted() {
    this.registerLogin()
  },
  methods: {
    removeRegisterLogin() {
      if (isWPSClient() && !isMobile()) {
        removeRegisterLogin()
      }
    },
    registerLogin() {
      // 兼容金山文档内嵌PC
      if (getQuery('utm_source') === 'WPS365_PC' && isIframe()) return
      if (isWPSClient() && !isMobile()) {
        try {
          this.$report.setChannel('wpsPCWinHome')
          registerLogin(
            () => {
              window.location.reload()
            },
            () => {
              // 做一个UI兼容处理，当退登，两秒后还没有登录其他账号时，展示登录页面。避免多账号快速登录出现页面闪动问题
              setTimeout(() => (this.show = true), 2000)
            }
          )
        } catch (err) {
          this.$message.warning('PCofficeLogin:' + err)
        }
      }
    },
    login() {
      callLogin()
    },
  },
}
</script>
<style lang="scss" module>
.wps-login-container {
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: #fff;
  z-index: 999;
  top: 0;
  top: 0;

  .wps-login-panel {
    width: 450px;
    background: #fff;
    border: 1px solid #e7e9eb;
    border-radius: 2px !important;
    margin: 200px auto;
    text-align: center;

    .header {
      line-height: 18px;
    }

    .header h2 {
      font-weight: 400;
      font-size: 18px;
      color: #424242;
      margin-top: 40px;
    }

    .header h3 {
      font-weight: 400;
      font-size: 12px;
      color: #8d8d8d;
      margin: 8px 0 28px;
    }

    .section a {
      display: inline-block;
      width: 260px;
      color: #fff;
      border-radius: 4px !important;
      outline: none;
      height: 44px;
      line-height: 44px;
      font-size: 14px;
    }

    .section a .wps-login-icon {
      float: left;
      width: 55px;
    }

    .section a .wps-login-icon .border {
      height: 44px;
      width: 54px;
      border-right: 1px solid #d8d8d8;
    }

    .section a .wps-login-icon.wechat .border {
      border-color: #58c167;
    }

    .section a .components-icons-box {
      font-size: 22px;
      float: left;
      margin: 0 14px;
      width: 26px;
    }

    .section .wps-email-login {
      margin-top: 16px;
      background: #fff;
      border: 1px solid #d8d8d8;
      color: #535252;
    }

    .section .wps-wechat-login {
      background: #38b54a;
    }

    .section .wps-wechat-login .wps-login-icon {
      border-color: #58c167;
    }

    .section .wps-email-login span.tip,
    .section .wps-wechat-login span.tip {
      display: inline-block;
      -webkit-transform: translateX(-22px);
      transform: translateX(-22px);
    }

    .section .wps-email-login {
      height: 44px;
      line-height: 44px;
    }

    .section .components-icons {
      vertical-align: text-top;
    }

    .footer span {
      color: #dbdbdb;
      font-size: 17px;
      margin: 0 10px;
    }

    .footer a {
      line-height: 84px;
      font-size: 14px;
      color: #535252;
    }

    .footer a:hover {
      cursor: pointer;
    }

    .footer .components-icons-box {
      font-size: 14px;
      margin-right: 5px;
      color: #414445;
    }
  }

  .icon-wechat {
    margin-top: 10px;
    width: 28px;
  }

  .icon-qq {
    margin-top: 5px;
    width: 29px;
  }

  .icon-shouji {
    margin-top: 32px;
    width: 20px;
  }
}
</style>
